import { render, staticRenderFns } from "./FormSubmitConfigModal.vue?vue&type=template&id=2a0b9420"
import script from "./FormSubmitConfigModal.vue?vue&type=script&lang=js"
export * from "./FormSubmitConfigModal.vue?vue&type=script&lang=js"
import style0 from "./FormSubmitConfigModal.vue?vue&type=style&index=0&id=2a0b9420&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports